var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { staticClass: "padding-add" },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small", "label-width": "75px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("el-date-picker", {
                        staticClass: "selWidth",
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          placement: "bottom-end",
                          placeholder: "自定义时间",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号码：" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: {
                          placeholder: "请输入订单号",
                          size: "small",
                          clearable: "",
                        },
                        model: {
                          value: _vm.tableFrom.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "orderNo", $$v)
                          },
                          expression: "tableFrom.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.seachList },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: { click: _vm.handleReset },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _vm.checkPermi(["admin:order:status:num"]) &&
              _vm.isNumber(_vm.orderChartType.all)
                ? _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.seachList },
                      model: {
                        value: _vm.tableFrom.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "status", $$v)
                        },
                        expression: "tableFrom.status",
                      },
                    },
                    [
                      _c("el-tab-pane", {
                        attrs: {
                          name: "all",
                          label:
                            "全部(" +
                            (_vm.orderChartType.all
                              ? _vm.orderChartType.all
                              : 0) +
                            ")",
                        },
                      }),
                      _c("el-tab-pane", {
                        attrs: {
                          name: "deleted",
                          label:
                            "已删除(" +
                            (_vm.orderChartType.deleted
                              ? _vm.orderChartType.deleted
                              : 0) +
                            ")",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:export:excel:order"],
                      expression: "['admin:export:excel:order']",
                    },
                  ],
                  on: { click: _vm.exports },
                },
                [_vm._v("导出")]
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
                "row-key": function (row) {
                  return row.orderId
                },
              },
            },
            [
              _vm.checkedCities.includes("订单号")
                ? _c("el-table-column", {
                    attrs: { label: "订单号", "min-width": "210" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", {
                                staticStyle: { display: "block" },
                                domProps: {
                                  textContent: _vm._s(scope.row.orderId),
                                },
                              }),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: scope.row.isDel,
                                      expression: "scope.row.isDel",
                                    },
                                  ],
                                  staticStyle: {
                                    color: "#ed4014",
                                    display: "block",
                                  },
                                },
                                [_vm._v("用户已删除")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3301523190
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("订单类型")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "orderType",
                      label: "订单类型",
                      "min-width": "110",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("收货人")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "realName",
                      label: "收货人",
                      "min-width": "100",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("商品信息")
                ? _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": true,
                      label: "商品信息",
                      "min-width": "400",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.productList &&
                              scope.row.productList.length
                                ? _c(
                                    "div",
                                    {
                                      attrs: { slot: "reference" },
                                      slot: "reference",
                                    },
                                    _vm._l(
                                      scope.row.productList,
                                      function (val, i) {
                                        return _c(
                                          "div",
                                          {
                                            key: i,
                                            staticClass:
                                              "tabBox acea-row row-middle",
                                            staticStyle: {
                                              "flex-wrap": "inherit",
                                            },
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "demo-image__preview mr10",
                                              },
                                              [
                                                _c("el-image", {
                                                  attrs: {
                                                    src: val.info.image,
                                                    "preview-src-list": [
                                                      val.info.image,
                                                    ],
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "text_overflow" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "tabBox_tit mr10",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        val.info.productName +
                                                          " | "
                                                      ) +
                                                        _vm._s(
                                                          val.info.sku
                                                            ? val.info.sku
                                                            : "-"
                                                        )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "tabBox_pice",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        "￥" + val.info.price
                                                          ? val.info.price +
                                                              " x " +
                                                              val.info.payNum
                                                          : "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3263947666
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("实际支付")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "payPrice",
                      label: "实际支付",
                      "min-width": "80",
                    },
                  })
                : _vm._e(),
              _vm.checkedCities.includes("支付方式")
                ? _c("el-table-column", {
                    attrs: { label: "支付方式", "min-width": "80" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.payTypeStr)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1599512067
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("订单状态")
                ? _c("el-table-column", {
                    attrs: { label: "订单状态", "min-width": "100" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", [
                                scope.row.refundStatus === 1 ||
                                scope.row.refundStatus === 2
                                  ? _c(
                                      "div",
                                      { staticClass: "refunding" },
                                      [
                                        [
                                          _c(
                                            "el-popover",
                                            {
                                              attrs: {
                                                trigger: "hover",
                                                placement: "left",
                                                "open-delay": 500,
                                              },
                                            },
                                            [
                                              _c(
                                                "b",
                                                {
                                                  staticStyle: {
                                                    color: "#f124c7",
                                                    cursor: "pointer",
                                                  },
                                                  attrs: { slot: "reference" },
                                                  slot: "reference",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.statusStr.value
                                                    )
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "pup_card flex-column",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      "退款原因：" +
                                                        _vm._s(
                                                          scope.row
                                                            .refundReasonWap
                                                        )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      "备注说明：" +
                                                        _vm._s(
                                                          scope.row
                                                            .refundReasonWapExplain
                                                        )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      "退款时间：" +
                                                        _vm._s(
                                                          scope.row
                                                            .refundReasonTime
                                                        )
                                                    ),
                                                  ]),
                                                  _c(
                                                    "span",
                                                    { staticClass: "acea-row" },
                                                    [
                                                      _vm._v(" 退款凭证： "),
                                                      scope.row
                                                        .refundReasonWapImg
                                                        ? _vm._l(
                                                            scope.row.refundReasonWapImg.split(
                                                              ","
                                                            ),
                                                            function (
                                                              item,
                                                              index
                                                            ) {
                                                              return _c(
                                                                "div",
                                                                {
                                                                  key: index,
                                                                  staticClass:
                                                                    "demo-image__preview",
                                                                  staticStyle: {
                                                                    width:
                                                                      "35px",
                                                                    height:
                                                                      "auto",
                                                                    display:
                                                                      "inline-block",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "el-image",
                                                                    {
                                                                      attrs: {
                                                                        src: item,
                                                                        "preview-src-list":
                                                                          [
                                                                            item,
                                                                          ],
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            }
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                display:
                                                                  "inline-block",
                                                              },
                                                            },
                                                            [_vm._v("无")]
                                                          ),
                                                    ],
                                                    2
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                      ],
                                      2
                                    )
                                  : _c("span", [
                                      _vm._v(_vm._s(scope.row.statusStr.value)),
                                    ]),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2323619182
                    ),
                  })
                : _vm._e(),
              _vm.checkedCities.includes("下单时间")
                ? _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "下单时间",
                      "min-width": "150",
                    },
                  })
                : _vm._e(),
              _c("el-table-column", {
                attrs: { label: "操作", width: "200", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        [
                          _vm.checkPermi(["admin:order:info"])
                            ? _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onOrderDetails(
                                        scope.row.orderId
                                      )
                                    },
                                  },
                                },
                                [_vm._v("详情")]
                              )
                            : _vm._e(),
                          _c("el-divider", {
                            attrs: { direction: "vertical" },
                          }),
                        ],
                        scope.row.paid === false &&
                        !scope.row.isAlterPrice &&
                        _vm.checkPermi(["admin:order:update:price"])
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.edit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("编辑")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        scope.row.statusStr.key === "notShipped" &&
                        scope.row.refundStatus === 0 &&
                        _vm.checkPermi(["admin:order:send"])
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.sendOrder(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("发送货")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        scope.row.statusStr.key === "spike" &&
                        scope.row.type === 0 &&
                        _vm.checkPermi(["admin:order:tracking:number:update"])
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpdateNumber(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("修改快递单号")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        scope.row.statusStr.key === "toBeWrittenOff" &&
                        scope.row.paid == true &&
                        scope.row.refundStatus === 0 &&
                        _vm.checkPermi(["admin:order:write:update"])
                          ? [
                              _c(
                                "a",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.onWriteOff(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("立即核销")]
                              ),
                              _c("el-divider", {
                                attrs: { direction: "vertical" },
                              }),
                            ]
                          : _vm._e(),
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click" } },
                          [
                            _c("span", { staticClass: "el-dropdown-link" }, [
                              _vm._v(" 更多"),
                              _c("i", {
                                staticClass:
                                  "el-icon-arrow-down el-icon--right",
                              }),
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _vm.checkPermi(["admin:order:status:list"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onOrderLog(
                                              scope.row.orderId
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("订单记录")]
                                    )
                                  : _vm._e(),
                                _vm.checkPermi(["admin:order:mark"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onOrderMark(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("订单备注")]
                                    )
                                  : _vm._e(),
                                scope.row.refundStatus === 1 &&
                                _vm.checkPermi(["admin:order:refund:refuse"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onOrderRefuse(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("拒绝退款")]
                                    )
                                  : _vm._e(),
                                scope.row.refundStatus === 1 &&
                                _vm.checkPermi(["admin:order:refund"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.onOrderRefund(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("立即退款")]
                                    )
                                  : _vm._e(),
                                scope.row.statusStr.key === "deleted" &&
                                _vm.checkPermi(["admin:order:delete"])
                                  ? _c(
                                      "el-dropdown-item",
                                      {
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.handleDelete(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("删除订单")]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "编辑订单",
            visible: _vm.dialogVisible,
            width: "500px",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _vm.dialogVisible
            ? _c("zb-parser", {
                attrs: {
                  "form-id": 104,
                  "is-create": _vm.isCreate,
                  "edit-data": _vm.editData,
                },
                on: {
                  submit: _vm.handlerSubmit,
                  resetForm: _vm.resetForm,
                  closeDialog: function ($event) {
                    _vm.dialogVisible = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作记录",
            visible: _vm.dialogVisibleJI,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisibleJI = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.LogLoading,
                  expression: "LogLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { border: "", data: _vm.tableDataLog.data },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "oid", label: "ID", "min-width": "80" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "changeMessage",
                  label: "操作记录",
                  "min-width": "280",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "操作时间",
                  "min-width": "280",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.tableFromLog.limit,
                  "current-page": _vm.tableFromLog.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableDataLog.total,
                },
                on: {
                  "size-change": _vm.handleSizeChangeLog,
                  "current-change": _vm.pageChangeLog,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("details-from", {
        ref: "orderDetail",
        attrs: { orderId: _vm.orderId },
      }),
      _c("order-send", {
        ref: "send",
        attrs: {
          orderId: _vm.orderId,
          expressListNormal: _vm.expressListNormal,
          expressListElec: _vm.expressListElec,
          orderDetail: _vm.orderDetail,
        },
        on: { submitFail: _vm.getList },
      }),
      _vm.RefuseVisible
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: "拒绝退款原因",
                visible: _vm.RefuseVisible,
                width: "500px",
                "before-close": _vm.RefusehandleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.RefuseVisible = $event
                },
              },
            },
            [
              _c("zb-parser", {
                attrs: {
                  "form-id": 106,
                  "is-create": 1,
                  "edit-data": _vm.RefuseData,
                },
                on: {
                  submit: _vm.RefusehandlerSubmit,
                  resetForm: _vm.resetFormRefusehand,
                  closeDialog: function ($event) {
                    _vm.RefuseVisible = false
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "退款处理",
            visible: _vm.refundVisible,
            width: "500px",
            "before-close": _vm.refundhandleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.refundVisible = $event
            },
          },
        },
        [
          _vm.refundVisible
            ? _c("zb-parser", {
                attrs: {
                  "form-id": 107,
                  "is-create": 1,
                  "edit-data": _vm.refundData,
                },
                on: {
                  submit: _vm.refundhandlerSubmit,
                  resetForm: _vm.resetFormRefundhandler,
                  closeDialog: function ($event) {
                    _vm.refundVisible = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }